import React from 'react';
import { HashRouter, Route, Redirect } from 'react-router-dom';
import { useHistory } from "react-router";
import LoginComponent from './Components/Auth/Login';
import ForgotUsername from './Components/Auth/ForgotUsername';
import ForgotPassword from './Components/Auth/ForgotPassword';
import Forgot from './Components/Auth/Forgot';
import Signup from './Components/Auth/Signup';
import AdminDashboard from './Components/Admin/AdminDashboard';
import SuperAdminDashboard from './Components/SuperAdmin/SuperAdminDashboard';
import Users from './Components/SuperAdmin/Users';
import SubscribeUsers from './Components/SuperAdmin/SubscribeUsers';
import Estimate from './Components/Admin/Estimate';
import Invoice from './Components/Admin/Invoice';
import NewInvoice from './Components/Admin/NewInvoice';
import Client from './Components/Admin/Client';
import ContractForm from './Components/Admin/ContractForm';
import SendContractForm from './Components/Admin/SendContractForm';
import AdditionalWorkaData from './Components/Admin/AdditionalWorkaData';
import Item from './Components/Admin/Item';
import NewEstimate from './Components/Admin/NewEstimate';
import './index.css';
import CheckOTP from './Components/Auth/CheckOTP';
import ResetPassword from './Components/Auth/ResetPassword';
import Taxes from './Components/Admin/Taxes';
import MyCompany from './Components/Admin/MyCompany';
import WebAndLink from './Components/Admin/WebAndLink';
import ChangePassword from './Components/Admin/ChangePassword';
import EditInvoice from './Components/Admin/EditInvoice';
import EditEsimate from './Components/Admin/EditEstimate';
import ViewInvoice from './Components/Admin/view-invoice/ViewInvoice';
import ViewEstimate from './Components/Admin/view-estimate/ViewEstimate';
import Payment from './Components/Admin/Payment';
import SendForm from './Components/Admin/SendForm';
import Forms from './Components/Admin/Forms';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { useEffect } from 'react';
import axios from "axios";
import APIModel from './Models/APIModel';
import './App.css';

// import 'bootstrap-css-only/css/bootstrap.min.css';
// import 'mdbreact/dist/css/mdb.css';


const App = () => {
    const history = useHistory();
    let token = localStorage.getItem("Token");
    useEffect(() => {
        if (!token) {
            return;
        }
        axios.get(APIModel.HOST + "check-user-subscription", {
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: "Bearer " + token,
            },
        })
            .then((res) => {
                if (res.data.status === false) {
                    logout();
                }
            })
            .catch((err) => console.log(err));
    }, [token])

    function logout() {
        localStorage.clear("token");
        history.push("/");
    }

    return (<
        div className="b" >
        <
        HashRouter >
            <
                Route path="/"
                exact component={LoginComponent}
            /> <
                Route path="/forgotUsername"
                component={ForgotUsername}
            /> <
                Route path="/forgotPassword"
                component={ForgotPassword}
            /> <
                Route exact path="/verify"
                component={CheckOTP}
            /> <
                Route exact path="/reset"
                component={ResetPassword}
            /> <
                Route path="/forgot"
                component={Forgot}
            /> <
                Route path="/signup"
                component={Signup}
            /> <
                Route exact path="/admin-dashboard"
                component={AdminDashboard}
            /> <
                Route exact path="/superadmin-dashboard"
                component={SuperAdminDashboard}
            /> <
                Route exact path="/superadmin-users"
                component={Users}
            /> <
                Route exact path="/superadmin-subscribe-users"
                component={SubscribeUsers}
            /> <
                Route exact path="/estimates"
                component={Estimate}
            /> <
                Route exact path="/estimates/new"
                component={NewEstimate}
            /> <
                Route exact path="/estimates/edit/:id"
                component={EditEsimate}
            /> <
                Route exact path="/estimates/view/:id"
                component={ViewEstimate}
            /> <
                Route exact path="/invoices"
                component={Invoice}
            /> <
                Route exact path="/invoices/new"
                component={NewInvoice}
            /> <
                Route exact path="/invoices/edit/:id"
                component={EditInvoice}
            /> <
                Route exact path="/invoices/view/:id"
                component={ViewInvoice}
            /> <
                Route exact path="/invoices/lien-form"
                component={ContractForm}
            /> <
                Route exact path="/estimates/lien-form"
                component={ContractForm}
            /> <
                Route exact path="/client"
                component={Client}
            /> <
                Route exact path="/item"
                component={Item}
            /> <
                Route exact path="/all-taxes"
                component={Taxes}
            /> <
                Route exact path="/company-detail"
                component={MyCompany}
            /> <
                Route exact path="/web-and-links"
                component={WebAndLink}
            /> <
                Route exact path="/change-password"
                component={ChangePassword}
            /> <
                Route exact path="/payment"
                component={Payment}
            /> <
                Route exact path="/send-lien-form"
                component={SendForm}
            /> <
                Route exact path="/setting"
                component={ChangePassword}
            /> <
                Route exact path="/send-lien-form-data"
                component={SendContractForm}
            /> 
            <
                Route exact path="/addition-work-data"
                component={AdditionalWorkaData}
            /> <
                Route exact path="/forms"
                component={Forms}
            /> <
        /HashRouter> <
        /div>
            );
}

// class App extends React.Component{
//     render(){
//         return (
//             <div className="b">
//                 <HashRouter>
//                 <Route path="/" exact component={LoginComponent} />
//                 <Route path="/forgotUsername" component={ForgotUsername} />
//                 <Route path="/forgotPassword" component={ForgotPassword} />
//                 <Route exact path="/verify" component={CheckOTP} />
//                 <Route exact path="/reset" component={ResetPassword} />
//                 <Route path="/forgot" component={Forgot} />
//                 <Route path="/signup" component={Signup} />
//                 <Route exact path="/admin-dashboard" component={AdminDashboard} />
//                 <Route exact path="/superadmin-dashboard" component={SuperAdminDashboard} />
//                 <Route exact path="/superadmin-users" component={Users} />
//                 <Route exact path="/superadmin-subscribe-users" component={SubscribeUsers} />
//                 <Route exact path="/estimates" component={Estimate} />
//                 <Route exact path="/estimates/new" component={NewEstimate} />
//                 <Route exact path="/estimates/edit/:id" component={EditEsimate} />
//                 <Route exact path="/estimates/view/:id" component={ViewEstimate} />
//                 <Route exact path="/invoices" component={Invoice} />
//                 <Route exact path="/invoices/new" component={NewInvoice} />
//                 <Route exact path="/invoices/edit/:id" component={EditInvoice} />
//                 <Route exact path="/invoices/view/:id" component={ViewInvoice} />
//                 <Route path="/invoices/lien-form" component={ContractForm} />
//                 <Route path="/estimates/lien-form" component={ContractForm} />
//                 <Route path="/client" component={Client} />
//                 <Route exact path="/item" component={Item} />
//                 <Route exact path="/all-taxes" component={Taxes} />
//                 <Route exact path="/company-detail" component={MyCompany} />
//                 <Route exact path="/web-and-links" component={WebAndLink} />
//                 <Route exact path="/change-password" component={ChangePassword} />
//                 <Route exact path="/payment" component={Payment} />
//                 <Route exact path="/send-lien-form" component={SendForm} />
//                 <Route path="/send-lien-form-data" component={SendContractForm} />
//                 </HashRouter>
//             </div> 
//         ); 
//     }
// }
export default App;